import { useQuery } from "@tanstack/react-query";
import { useAgentSdk } from "@/sdk";
import { TwilioChatTask } from "@/twilio/chat";

import { selectChatMessages, useChatStore } from "./chat.store";
import type { ChatTask } from "./chatTask";
import type { ChatMessage } from "./types";

// TODO: Resolve the Twilio race condition with tasks and conversations instead of relying on a query hook.
const isTaskRaceConditionFixEnabled = (activeChatTask: ChatTask) =>
    activeChatTask instanceof TwilioChatTask && activeChatTask.status === "assigned";

/**
 * Hook to get sorted messages for the active chat task.
 * Uses a selector to only re-render when this specific chat's messages change,
 * preventing unnecessary re-renders when other chats update.
 */
export function useActiveChatMessages(activeChatTask: ChatTask): ChatMessage[] {
    const agentSdk = useAgentSdk();
    const messages = useChatStore(selectChatMessages(activeChatTask.chatId));

    // TODO:// find a way to call getMessages within creation of new task (currently doesn't work bc of race-condition)
    useQuery({
        queryKey: ["useActiveChatMessages", activeChatTask.chatId, activeChatTask.id],
        queryFn: async () => {
            await agentSdk.getMessages(activeChatTask);
        },
        enabled: messages.length === 0 && isTaskRaceConditionFixEnabled(activeChatTask),
        staleTime: 1000 * 60 * 1, // 1 minutes - allows retry if initial fetch fails
    });

    return messages;
}
